module.exports = "/img/cate-sport.bee6293c.png";